import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

function PricingIcon({ subtitle, ...rest }) {
  const theme = useTheme();

  return (
    <Box
      component="li"
      paddingTop=".25rem"
      paddingBottom=".25rem"
      display="flex"
      alignItems="baseline"
      {...rest}
    >
      <Box
        component="span"
        sx={{
          width: 5,
          height: 5,
          minWidth: 5,
          borderRadius: '50%',
          backgroundColor: theme.palette.gray[500],
          marginTop: '0.35rem',
          alignSelf: 'flex-start',
        }}
      />
      <Box
        paddingLeft=".75rem"
        color={theme.palette.gray[700]}
        textAlign="left"
        fontSize="0.75rem"
        sx={{ flex: 1, lineHeight: 1.4 }}
      >
        {subtitle}
      </Box>
    </Box>
  );
}

PricingIcon.propTypes = {
  subtitle: PropTypes.node,
};

export default PricingIcon;
